import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import NoInfo from "../../../components/NoInfo";
import PrimeTableFooter from "../../../components/PrimeTableFooter";
import NumberUtil from "../../../utility/NumberUtil";

export const FootprintTable = ({ rows, editItem, deleteItem, btnReadMore, isEditable }) => {
  const { t } = useTranslation();

  const distributionRatioTemplate = (rowData, props) => {
    if (rowData) {
      return <span>{rowData?.distributionRatio && `${rowData.distributionRatio}%`}</span>;
    }
  };

  const actionBodyTemplate = (rowData) => {
    if (rowData) {
      return (
        <>
          <Button
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            tooltip={t("button.edit")}
            onClick={() => {
              editItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
          </Button>
          <Button
            rounded
            text
            severity="danger"
            className="p-button-icon-only"
            tooltip={t("button.delete")}
            onClick={() => {
              deleteItem(rowData);
            }}
            disabled={!isEditable}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash-can" />
          </Button>
          {/* <Button
                rounded text severity="secondary"
                className="p-button-icon-only"
                tooltip={t('button.copy')}
            >
                <FontAwesomeIcon icon="fa-solid fa-copy" />
            </Button>
           */}
        </>
      );
    }
  };

  const formatWithCommastTemplate = (value) => {
    return <>{<>{NumberUtil.formatWithCommas(value)}</>}</>;
  };

  return (
    <>
      <DataTable
        stripedRows
        value={rows}
        className="white-data-table hover-highlight no-shadow mt-1"
        tableStyle={{ minWidth: "50rem" }}
        footer={rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
        emptyMessage={<NoInfo panel="table" size="md" />}
      >
        <Column header={t("itemNo")} body={(rowData, { rowIndex }) => `${rowIndex + 1}`} style={{ width: "100px" }} />
        <Column style={{ width: "200px" }} field="dataName" header={t("activityDataName")} />
        <Column
          style={{ width: "80px", textAlign: "right" }}
          field="dataValue"
          header={t("carbonFootprintValue")}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
          body={(rowData) => formatWithCommastTemplate(rowData.dataValue)}
        />
        <Column style={{ width: "100px" }} field="dataUnitName" header={t("unit")} />
        <Column
          style={{ width: "150px" }}
          field="distributionRatio"
          header={`${t("allocationRatio")}(%)`}
          body={distributionRatioTemplate}
        />
        <Column style={{ width: "150px" }} field="coefName" header={t("emissionFactorName")} />
        <Column
          style={{ width: "150px", textAlign: "right" }}
          field="coefValue"
          header={<>{t("emissionFactor")}</>}
          headerStyle={{ textAlign: "right" }}
          headerClassName="right-header"
          body={(rowData) => formatWithCommastTemplate(rowData.coefValue)}
        />
        <Column style={{ width: "100px" }} field="coefUnitName" header={t("unit")} />
        {/* <Column field="emissionCoefficientSource" header="數據來源"></Column> */}
        <Column style={{ width: "150px" }} body={actionBodyTemplate} header={t("action")} />
      </DataTable>
    </>
  );
};

export default FootprintTable;
